<template>
  <div class='pie'>
    <div class="title">
      {{title}}
    </div>
    <div :id="id" style="width: 100%;height:300px;" v-if="detail.length"></div>
    <!-- <div v-if="loading" class="demo-loading-container">
        <a-spin />
    </div>
    <div v-if="!detail.length&&!loading" class="demo-loading-container">
        <a-empty />
    </div> -->
  </div>

</template>

<script>
  import echarts from 'echarts'
  import {lesseeGetBusinessStat} from '../../../../api/tenant.js'
  export default {
    name: "pie",
    props: {
      title: String,
      data: Array,
    },
    components: {},
    data() {
      return {
        id: "pie" + Math.random(),
        flag: true,
        detail:[],
        loading: false
      }
    },
    methods: {
        init(){
            this.loading = true
            lesseeGetBusinessStat().then(res => {
                let data = res.data
                if (data.code === '000') {
                    this.detail = data.content
                    this.$nextTick(function () {
                        this.initEcharts()
                    })
                } else {
                    this.detail = []
                }
            }).catch(err => {
                console.log(err);
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        initEcharts(){
            let data = this.detail
            let formatNumber = function(num) {
                let reg = /(?=(\B)(\d{3})+$)/g;
                return num.toString().replace(reg, ',');
            }
            let colorArr = ['#56b5ff', '#fdd158', '#bee485', '#9de8f6', '#f5736e']
            let legendData = []
            for (let i = 0; i < data.length; i++) {
                legendData.push({value: data[i].num, name: data[i].name,ratio: data[i].ratio,itemStyle:{color:colorArr[i]}})
            }
            if (!this.flag) {
                return false
            }
            this.$nextTick(function () {
                this.flag = false
                var myChart = echarts.init(document.getElementById(this.id));
                let option = {
                    backgroundColor: '#fff',
                    color: colorArr,
                    tooltip: {
                        trigger: 'item'
                    },
                    title: {
                        text: '行业分布',
                        textAlign:"center",
                        x: '34.5%',
                        y: 'center',
                        textStyle: {
                            fontSize: 20,
                            fontWeight: '600',
                            color: '#333',
                            // padding: [10, 0]
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        icon: 'circle',
                        x: '60%',
                        y: 'center',
                        itemWidth: 15,
                        itemHeight: 15,
                        align: 'left',
                        textStyle: {
                            color: '#666',
                            rich: {
                                name: {
                                    align: 'left',
                                },
                                value: {
                                    
                                },
                                c: {
                                    width: 35,
                                    // padding: [0, 5, 0, 0]
                                }
                            }
                        },
                        formatter: function(name) {
                            let res = legendData.filter(v => v.name === name);
                            res = res[0] || {};
                            let nameLit = '';
                            if(name.length>12){
                                nameLit = name.substring(0,12) + '...'
                            }else{
                                nameLit = name;
                            }
                            let percent = Math.floor(res.ratio * 10000) / 100
                            return '{name|' + nameLit + '}  |  {c|' + percent + '%}  {value|' + formatNumber(res.value) + '}'
                        }
                    },
                    series: [{
                        type: 'pie',
                        center: ['35%', '50%'],
                        radius: ['40%', '65%'],
                        data: legendData,
                        clockwise: false,
                        avoidLabelOverlap: false,
                        itemStyle: {
                            normal: {
                                borderColor: '#fff',
                                borderWidth: 1
                            }
                        },
                        labelLine: {
                            normal: {
                                length: 20,
                                length2: 20
                            }
                        },
                        label: {
                            normal: {
                                show: false
                            }
                        },
                    }]
                };
                myChart.setOption(option);
                myChart.on('click', (params) => {
                    this.$emit('legendselectchanged',params.data)
                });
            })
        }
    },
    
    created() {
        this.init()
    },
    mounted() {
    
    },
  }
</script>

<style scoped lang="scss">
  .pie {
    width: 50%;
    min-height: 300px;
    position: relative;
    background: #fff;
    
    .demo-loading-container {
      padding:20px 0;
      text-align:center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
  
  .title {
    font-size: 22px;
    color: #3B4859;
    font-weight: 700;
    width: 600px;
    text-align: left;
    padding-top: 30px;
    margin-left:24px;
  }
</style>
